import { SagaIterator } from 'redux-saga';
import { all, call, takeEvery } from 'redux-saga/effects';
import { requestPuppy, isApiError } from '@wix/da-http-client';
import {
  PapiDaSharedOriginalsOrder,
  PapiRequestDaSharedOriginalsOrder,
} from '@wix/da-papi-types';
import { fetchOriginalsOrderDetails } from '../actions/originals';
import { Fake, users } from '@wix/da-sample-data';
import { makeTiptapEditorText } from '@wix/da-sample-data/dist/src/fakes/editorText';

export function* fetchOriginalsOrderDetailsSaga(
  action: ReturnType<typeof fetchOriginalsOrderDetails>
): SagaIterator {
  const { deviationId, orderId, onSuccess, onError } = action.payload;
  const response = yield call(
    requestPuppy,
    {
      method: 'get',
      url: `/originals/order`,
      params: {
        originals_deviationid: deviationId,
        orderid: orderId,
      } as PapiRequestDaSharedOriginalsOrder,
    },
    () =>
      ({
        deviation: Fake.makeEmptyDeviation(),
        response: {
          responseId: 123,
          status: 'new',
          paidTs: '2026-01-01',
          acceptedTs: '2026-01-01',
          deliveredTs: '2026-01-01',
          rejectedTs: '2026-01-01',
          user: users[0],
          orderAnswers: [
            {
              question: {
                questionId: 123,
                question: makeTiptapEditorText(['free text question']),
                isRequired: true,
                type: 'free_text',
                position: 0,
              },
              answer: makeTiptapEditorText(['blah', 'foobar']),
            },
          ],
        },
      }) as PapiDaSharedOriginalsOrder,
    'dashared'
  );
  if (response && !isApiError(response)) {
    yield call(onSuccess, response.response);
  } else {
    yield call(onError, response);
  }
}

export default function* originalsSaga() {
  yield all([
    takeEvery(fetchOriginalsOrderDetails, fetchOriginalsOrderDetailsSaga),
  ]);
}
